import React from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    useTheme,
    useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { NavbarProps } from '../../types/navigation.types';
import { MobileDrawer } from './MobileDrawer';
import { DesktopNavigation } from './DesktopNavigation';
import { routes } from '../../config/routes.config';

const navItems = routes.map(({ path, label }) => ({
    path,
    label
}));

export const Navbar: React.FC<NavbarProps> = ({ title, items }) => {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

    return (
        <>
            <AppBar position="fixed" color="default" elevation={1}>
                <Toolbar>
                    {isMobile && (
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ mr: 2 }}
                        >
                            <MenuIcon />
                        </IconButton>
                    )}
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ flexGrow: 1, fontWeight: 700 }}
                    >
                        {title}
                    </Typography>
                    {!isMobile && <DesktopNavigation items={items} />}
                </Toolbar>
            </AppBar>
            <MobileDrawer
                items={items}
                open={mobileOpen}
                onClose={handleDrawerToggle}
            />
            <Toolbar /> {/* Spacer for fixed AppBar */}
        </>
    );
}; 